// @ts-nocheck
import { checkboxSizes } from "@insite/mobius/Checkbox";
import { RadioStyle } from "@insite/mobius/Radio";
import getColor from "@insite/mobius/utilities/getColor";
import { RadioStyleProps } from "@store/MobiusOverrides/Radio/Radio";
import { RadioGroupStyleProps } from "@store/MobiusOverrides/RadioGroup/RadioGroup";
import { checkboxDescriptionSpacingStyles } from "@store/Themes/common/mixins/checkbox";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusOutlineStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
/* Store Custom Code - End */

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/Checkbox ------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const radio: Styleguide["radio"] = {
    defaultProps: {
        css: css<RadioStyleProps>`
            ${({ _sizeVariant }) => {
                const { borderWidth, boxSpacing, offset } = checkboxSizes[_sizeVariant] as any;

                return css`
                    input {
                        & + label {
                            word-break: break-word;
                            cursor: pointer;

                            &::before {
                                margin-right: ${pxToRem(boxSpacing)};
                                border: ${pxToRem(borderWidth)} solid ${getColor("common.border")}; /* Store Custom Code */
                                transition: ${transitionHoverStyles("border-color")}; /* Store Custom Code */
                            }

                            /* Store Custom Code - Start */
                            &:hover {
                                &::before {
                                    border-color: ${getColor("common.borderDark")};
                                }
                            }

                            &::after {
                                transform: scale(1.4);
                            }
                            /* Store Custom Code - End */

                            &::before,
                            &::after {
                                margin-top: ${pxToRem(offset)};
                            }
                        }

                        &:disabled + label {
                            cursor: default;

                            &::before {
                                border-color: ${getColor("common.disabledDark")};
                                background-color: ${getColor("common.disabled")};
                            }

                            &::after {
                                color: ${getColor("common.disabledDark")};
                            }
                        }

                        &:checked:not(:disabled) + label {
                            &::before {
                                border-color: ${getColor("primary")};
                                background-color: ${getColor("common.background")};
                            }

                            &::after {
                                color: ${getColor("primary")};
                            }
                        }

                        &:focus,
                        &:focus-visible {
                            & + label::before {
                                ${x => focusOutlineStyles(`-${pxToRem(borderWidth)}`, pxToRem(borderWidth))}
                                box-shadow: none;
                            }
                        }

                        &:not(:focus-visible) + label::before {
                            outline: none;
                        }
                    }
                `;
            }}
        ` as any,
    },
    groupDefaultProps: {
        css: css<RadioGroupStyleProps>`
            ${checkboxDescriptionSpacingStyles()}
            ${({ _sizeVariant = "default", horizontal }) => {
                const { itemSpacing } = checkboxSizes[_sizeVariant] as any;

                if (horizontal) {
                    return css`
                        &::before {
                            content: "";
                            display: block;
                            margin-top: -${pxToRem(itemSpacing)};
                        }

                        > ${RadioStyle} {
                            margin-top: ${pxToRem(itemSpacing)};
                            margin-right: 1em;

                            &:last-child {
                                margin-right: 0;
                            }
                        }
                    `;
                }

                return css`
                    ${RadioStyle} + ${RadioStyle} {
                        margin-top: ${pxToRem(itemSpacing)};
                    }
                `;
            }}
        ` as any,
        /* Store Custom Code - Start */
        errorProps: {
            weight: "normal",
        },
        /* Store Custom Code - End */
    },
};

export default radio;
